const Mail = () => {
  return(
    <div className="flex items-center  text-textColor gap-4 fixed bottom-40 -right-44 rotate-90">
         <div data-aos="fade-down-left">
        <a href="mailto:  kishunsah783@gmail.com" className="font-mono text-lg hover:text-primaryColor hover:-translate-x-2 translate transform">
        kishunsah783@gmail.com
        </a>
        </div>
        <hr className="boder-[2px] w-40 rounded-full bg-bgColor border-textColor " />
    </div>
  )
}
export default Mail;